// Portabilite.vue

<template>
    <v-container>
       <v-row>
          <v-col cols='8'><h1>Déjà client ?</h1></v-col>
          <v-col cols='4' class="text-right"><v-btn to="/souscription/offresbox/portabilite">Retour</v-btn></v-col>
       </v-row>
      <v-divider></v-divider>
      <br/>
      <br/><br/>

      <v-row>
         <v-col cols='12' sm='12' md='6'><span class='para'>Etes-vous déjà client à une offre box SFR ?</span></v-col>
         <v-col cols='12' sm='12' md='6' id='reponse'>
            <v-btn class='pl-10 pr-10 font-weight-black' :class="{ sel: isDejaClient('O')}" @click="ChoixDejaClient('O')">Oui</v-btn>
            <v-btn class='ml-12 pl-10 pr-10 font-weight-black' :class="{ sel: isDejaClient('N')}" @click="ChoixDejaClient('N')" >Non</v-btn>
         </v-col>
      </v-row>
      
      <br/><br/>

      <v-row justify="center" v-if="dejaClient=='O'">
        <v-col cols="12" sm="8" md="8" lg="8">
          <v-text-field
            label="Numéro de téléphone fixe actuel"
            prepend-icon="mdi-phone-dial"
            outlined
            v-model="numFixe"
          ></v-text-field>
        </v-col>
      </v-row>

      <br/><br/><br/>

      <v-row v-if="dejaClient=='O'">
          <v-spacer></v-spacer>
          <v-col cols='4' class="text-right"><v-btn color="success" @click="validationDejaClient()">Poursuivre</v-btn></v-col>
       </v-row>
    

    </v-container>
</template>
<script>
export default {
  data () {
     return {
        dejaClient: null,
        numFixe: null
     }
  },
  mounted: async function () {
    this.initDejaClientFromSession();
  },
  methods: {
     ChoixDejaClient: function(choix) {
        this.dejaClient = choix;

        // enregistrement du choix en session
         const sessionSouscriptionDejaClient = this.$globalService.setSessionSouscription('dejaClient',this.dejaClient);
         if(sessionSouscriptionDejaClient == null || !sessionSouscriptionDejaClient.dejaClient){
         this.$dialog.error({
            text: "Une erreur s'est produite",
            title: 'Erreur',
            persistent: false,
            actions: {
               false: 'Fermer'
            }
         })
         return;
         }
         if(this.dejaClient == 'N')
            this.$router.push({ name: "Recap" });

     },
     isDejaClient: function(choix) {
        if(this.dejaClient == choix) {
           return true;
        } else {
           return false;
        }
     },
     initDejaClientFromSession: function() {
        var sessionSouscription = this.$globalService.getSessionSouscription();
        if(sessionSouscription != null) {
          this.dejaClient = sessionSouscription.dejaClient;
          this.numFixe = sessionSouscription.numFixe;
        }
     },
     validationDejaClient: function() {

      if (!this.numFixe) {
        this.$dialog.warning({
          text: "Veuillez renseigner le numéro de téléphone fixe actuel",
          title: "Attention",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
        return;
      } else {
        // enregistrement du numFixe en session
        const sessionSouscriptionNumFixe = this.$globalService.setSessionSouscription(
          "numFixe",
          this.numFixe
        );
        if (
          sessionSouscriptionNumFixe == null ||
          !sessionSouscriptionNumFixe.numFixe
        ) {
          this.$dialog.error({
            text: "Une erreur s'est produite - 3589",
            title: "Erreur",
            persistent: false,
            actions: {
              false: "Fermer",
            },
          });
          return;
        } else {
          this.$router.push({name: 'Recap'});
        }
      }
       
     }
  }
}
</script>

<style>
/*    #reponse .v-btn:hover {
      background-color: var(--v-primary-base);
      color:white;

   } */
   #reponse .sel {
      background-color: var(--v-primary-base);
      color:white;
   }
</style>